// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Hover from "../../primitives/Hover.res.js";
import * as React from "react";
import * as Button from "../actions/Button.res.js";
import * as Spaces from "../theme/Spaces.res.js";
import * as StyleX from "../../externals/StyleX.res.js";
import * as Stdlib_Int from "@rescript/runtime/lib/es6/Stdlib_Int.js";
import * as Stdlib_Math from "@rescript/runtime/lib/es6/Stdlib_Math.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Float from "@rescript/runtime/lib/es6/Stdlib_Float.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ReactUpdateDebounced from "../../primitives/ReactUpdateDebounced.res.js";
import * as UseResizeObserver from "react-aria/private/utils/useResizeObserver";
function stepTowards(from, to, progress) {
  if (progress <= 0) {
    return from;
  }
  if (progress >= 1) {
    return to;
  }
  let distance = to - from | 0;
  let shift = Stdlib_Math.Int.ceil(progress * (Math.abs(distance) - 1 | 0));
  if (distance >= 0) {
    return from + shift | 0;
  } else {
    return from - shift | 0;
  }
}
function useItemsInView(layout) {
  let match;
  if (typeof layout !== "object") {
    match = [undefined, undefined, undefined];
  } else {
    let match$1 = layout._0;
    match = [match$1.min, match$1.base, match$1.max];
  }
  let max = match[2];
  let base = match[1];
  let min = match[0];
  let resolve = () => Stdlib_Option.map(base, base => {
    let viewportWidth = window.innerWidth;
    let min$1 = Math.max(Stdlib_Option.mapOr(min, base, min => Math.min(min, base)), 1);
    let max$1 = Stdlib_Option.mapOr(max, base, max => Math.max(max, base));
    let progressBetween = (startWidth, endWidth) => (viewportWidth - startWidth) / (endWidth - startWidth);
    let count = viewportWidth < 1024 ? stepTowards(base, min$1, progressBetween(1024, 768)) : viewportWidth > 1600 ? stepTowards(base, max$1, progressBetween(1600, 2400)) : base;
    return Stdlib_Int.clamp(min$1, max$1, count);
  });
  let match$2 = React.useState(resolve);
  let setItemsInView = match$2[1];
  React.useEffect(() => {
    setItemsInView(param => resolve());
    if (base === undefined) {
      return;
    }
    let onResize = param => setItemsInView(param => resolve());
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, [min, base, max]);
  return match$2[0];
}
let styles = {
  PaginationIndicator_indicator: {
    "display-k1xSpc": "display-x1rg5ohu",
    "height-kZKoxP": "height-x36qwtl",
    "marginLeft-koQZXg": "marginLeft-xwl1d5",
    "width-kzqmXN": "width-xvy4d1p",
    $$css: "wino-gc:src/resources/layout-and-structure/SliderTrack.res.js:94"
  }
};
function indicatorStyleProps(active) {
  return Stylex.props(styles.PaginationIndicator_indicator, {
    backgroundColor: active ? "#25243a" : "#d7d7e0"
  });
}
function SliderTrack$PaginationIndicator(props) {
  let trackRef = props.trackRef;
  let gap = props.gap;
  let itemsInView = props.itemsInView;
  let match = React.useState(() => 0);
  let setTotalPages = match[1];
  let totalPages = match[0];
  let match$1 = React.useState(() => 0);
  let setCurrentPage = match$1[1];
  let currentPage = match$1[0];
  let handleTotalPages = React.useCallback(() => {
    let domElement = trackRef.current;
    if (domElement == null) {
      return;
    }
    let scrollWidth = domElement.scrollWidth;
    let clientWidth = domElement.clientWidth;
    let totalGapShift = Spaces.toFloat(gap) * itemsInView;
    let nextTotalPages = Stdlib_Math.Int.ceil((scrollWidth - totalGapShift) / clientWidth);
    if (totalPages !== nextTotalPages) {
      setTimeout(() => setTotalPages(param => nextTotalPages), 0);
      return;
    }
  }, [trackRef, totalPages, itemsInView]);
  UseResizeObserver.useResizeObserver({
    ref: trackRef,
    onResize: handleTotalPages
  });
  let handleCurrentPage = React.useCallback(() => {
    let domElement = trackRef.current;
    if (domElement == null) {
      return;
    }
    let scrollLeft = domElement.scrollLeft;
    let clientWidth = domElement.clientWidth;
    let gapShift = Spaces.toFloat(gap) * (currentPage - 1 | 0);
    let nextCurrentPage = Stdlib_Math.Int.ceil((scrollLeft - gapShift) / clientWidth) + 1 | 0;
    if (currentPage !== nextCurrentPage) {
      setTimeout(() => setCurrentPage(param => nextCurrentPage), 0);
      return;
    }
  }, [trackRef, currentPage]);
  React.useLayoutEffect(() => {
    let domElement = trackRef.current;
    if (!(domElement == null)) {
      handleTotalPages();
      handleCurrentPage();
      domElement.addEventListener("scroll", handleCurrentPage);
      return () => {
        domElement.removeEventListener("scroll", handleCurrentPage);
      };
    }
  }, [trackRef.current, handleTotalPages, handleCurrentPage]);
  let debouncedCurrentPage = ReactUpdateDebounced.use(currentPage, 20);
  let match$2 = {
    className: "lineHeight-x14ju556 textAlign-x1hr2gdg margin-xjprq6h position-x10l6tqk right-x3m8u43 top-x13vifvy zIndex-x1vjfegm",
    "data-style-src": "wino-gc:src/resources/layout-and-structure/SliderTrack.res.js:85"
  };
  if (totalPages <= 10) {
    return JsxRuntime.jsx("ul", {
      children: Stdlib_Array.fromInitializer(totalPages, index => {
        let active = index === (debouncedCurrentPage - 1 | 0);
        let match = indicatorStyleProps(active);
        return JsxRuntime.jsx("li", {
          className: match.className,
          style: match.style
        }, index.toString());
      }),
      className: match$2.className,
      style: match$2.style
    });
  } else {
    return null;
  }
}
function useScrollable(trackRef, end) {
  let match = React.useState(() => false);
  let setScrollable = match[1];
  let scrollable = match[0];
  let handleScrollable = React.useCallback(() => {
    let domElement = trackRef.current;
    if (domElement == null) {
      return;
    }
    let next = end ? ((domElement.scrollLeft | 0) + domElement.clientWidth | 0) < (domElement.scrollWidth - 1 | 0) : domElement.scrollLeft > 1;
    if (scrollable !== next) {
      return setScrollable(param => next);
    }
  }, [trackRef, scrollable]);
  React.useLayoutEffect(() => {
    let domElement = trackRef.current;
    if (!(domElement == null)) {
      handleScrollable();
      domElement.addEventListener("scroll", handleScrollable);
      return () => {
        domElement.removeEventListener("scroll", handleScrollable);
      };
    }
  }, [trackRef.current, handleScrollable]);
  UseResizeObserver.useResizeObserver({
    ref: trackRef,
    onResize: handleScrollable
  });
  return scrollable;
}
let styles$1 = {
  SlideButton_root: {
    "borderRadius-kaIpWk": "borderRadius-xorixrz",
    "transition-kmkexE": "transition-x1myia39",
    "position-kVAEAm": "position-x10l6tqk",
    "top-k87sOh": "top-xwa60dl",
    "zIndex-kY2c9j": "zIndex-x1n327nk",
    $$css: "wino-gc:src/resources/layout-and-structure/SliderTrack.res.js:230"
  }
};
function styleProps(end, show, compact) {
  return Stylex.props(styles$1.SlideButton_root, {
    opacity: show ? 1 : 0,
    pointerEvents: show ? "auto" : "none",
    transform: compact ? "translateY(-50%) scale(0.95)" : end ? `translate(20%, -50%)` : `translate(-20%, -50%)`,
    boxShadow: compact ? "none" : "rgba(0, 0, 0, 0.07) 0px 3px 4px, rgba(0, 0, 0, 0.04) 0px 0px 4px",
    left: end ? "initial" : "0",
    right: end ? "0" : "initial"
  });
}
function itemsBounds(trackElement) {
  let trackLeft = trackElement.getBoundingClientRect().left;
  let scrollLeft = trackElement.scrollLeft;
  return Array.prototype.slice.call(trackElement.children).map(item => {
    let rect = item.getBoundingClientRect();
    let left = rect.left - trackLeft + scrollLeft;
    return [left, left + rect.width];
  });
}
function slideScrollLeft(trackElement, end) {
  let scrollLeft = trackElement.scrollLeft;
  let width = trackElement.clientWidth;
  let maxScrollLeft = trackElement.scrollWidth - width;
  let snapScrollLeft = right => right - width + 1;
  let items = itemsBounds(trackElement);
  let target;
  if (end) {
    let match = items.find(param => param[1] > scrollLeft + width + 1);
    if (match !== undefined) {
      let nextLeft = match[0];
      target = Stdlib_Array.reduce(items, snapScrollLeft(match[1]), (target, param) => {
        let right = param[1];
        if (snapScrollLeft(right) <= nextLeft - 1) {
          return Math.max(target, snapScrollLeft(right));
        } else {
          return target;
        }
      });
    } else {
      target = maxScrollLeft;
    }
  } else {
    let match$1 = items.findLast(param => param[0] < scrollLeft - 1);
    target = match$1 !== undefined ? snapScrollLeft(match$1[1]) : 0;
  }
  return Stdlib_Float.clamp(0, maxScrollLeft, target);
}
function SliderTrack$SlideButton(props) {
  let trackRef = props.trackRef;
  let compact = props.compact;
  let __end = props.end;
  let end = __end !== undefined ? __end : false;
  let handleControl = React.useCallback(() => {
    let domElement = trackRef.current;
    if (domElement == null) {
      return;
    }
    let left = Math.round(slideScrollLeft(domElement, end)) | 0;
    domElement.scrollTo({
      left: left,
      behavior: "smooth"
    });
  }, [trackRef]);
  let icon = end ? "arrow_right" : "arrow_left";
  let match = styleProps(end, props.show, compact);
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(Button.make, {
      size: compact ? "small" : "medium",
      shape: "pill",
      icon: icon,
      onPress: handleControl
    }),
    className: match.className,
    style: match.style
  });
}
let styles$2 = {
  track: {
    "scrollbarWidth-k5wCbM": "scrollbarWidth-x4fuk5f",
    "scrollPaddingInline-katHQp": "scrollPaddingInline-x1n66eit",
    "scrollSnapType-kc424l": "scrollSnapType-x16yixiu",
    "alignItems-kGNEyG": "alignItems-x1cy8zhl",
    "display-k1xSpc": "display-x78zum5",
    "marginInline-kUOVxO": "marginInline-xz95peq",
    "overflow-kVQacm": "overflow-xysyzu8",
    "paddingInline-kg3NbH": "paddingInline-x1gbt3hs",
    $$css: "wino-gc:src/resources/layout-and-structure/SliderTrack.res.js:329"
  },
  item: {
    "scrollSnapAlign-k5xd4v": "scrollSnapAlign-x83psoy",
    "flexShrink-kmuXW": "flexShrink-x2lah0s",
    $$css: "wino-gc:src/resources/layout-and-structure/SliderTrack.res.js:339"
  }
};
function edgeFadeMask(startFade, endFade, compact) {
  let stops = (active, fromEnd) => {
    if (active) {
      if (compact) {
        return [`transparent ` + (fromEnd ? `calc(100% - ` + "0px" + `)` : "0px"), `rgba(0, 0, 0, 0.3) ` + (fromEnd ? `calc(100% - ` + "32px" + `)` : "32px"), `black ` + (fromEnd ? `calc(100% - ` + "50px" + `)` : "50px")];
      } else {
        return [`transparent ` + (fromEnd ? `calc(100% - ` + "0px" + `)` : "0px"), `black ` + (fromEnd ? `calc(100% - ` + "35px" + `)` : "35px")];
      }
    } else {
      return [`black ` + (fromEnd ? `calc(100% - ` + "0px" + `)` : "0px")];
    }
  };
  let startStops = stops(startFade, false);
  let endStops = stops(endFade, true).toReversed();
  return `linear-gradient(to right, ` + startStops.concat(endStops).join(", ") + `)`;
}
function trackStyleProps(gap, startFade, endFade, compact, stretchItems) {
  return Stylex.props(styles$2.track, stretchItems ? {
    alignItems: "stretch"
  } : {}, {
    maskImage: edgeFadeMask(startFade, endFade, compact),
    columnGap: StyleX.toPx(Spaces.toFloat(gap))
  });
}
function itemStyleFromParams(cols, gap, stretchItems) {
  let cols$1 = String(cols);
  let gapPx = StyleX.toPx(Spaces.toFloat(gap));
  return Stylex.props(styles$2.item, stretchItems ? {
    display: "flex"
  } : {}, {
    flexBasis: `calc(100% / ` + cols$1 + ` - ` + gapPx + ` / ` + cols$1 + ` * (` + cols$1 + ` - 1))`
  });
}
function adaptativeItemStyleProps(stretchItems) {
  return {
    0: {
      className: "scrollSnapAlign-x83psoy flexShrink-x2lah0s",
      "data-style-src": "wino-gc:src/resources/layout-and-structure/SliderTrack.res.js:339"
    },
    1: {
      className: "scrollSnapAlign-x83psoy flexShrink-x2lah0s",
      style: {
        display: "flex"
      },
      "data-style-src": "wino-gc:src/resources/layout-and-structure/SliderTrack.res.js:339"
    }
  }[!!stretchItems << 0];
}
function SliderTrack(props) {
  let __stretchItems = props.stretchItems;
  let __showSlideButtons = props.showSlideButtons;
  let __showIndicator = props.showIndicator;
  let __layout = props.layout;
  let __gap = props.gap;
  let __compact = props.compact;
  let compact = __compact !== undefined ? __compact : false;
  let gap = __gap !== undefined ? __gap : "normal";
  let layout = __layout !== undefined ? __layout : "Adaptative";
  let showIndicator = __showIndicator !== undefined ? __showIndicator : false;
  let showSlideButtons = __showSlideButtons !== undefined ? __showSlideButtons : false;
  let stretchItems = __stretchItems !== undefined ? __stretchItems : false;
  let ref = React.useRef(null);
  let trackRef = Stdlib_Option.getOr(props.trackRef, React.useRef(null));
  let match = Hover.use(ref, undefined, undefined);
  let containerHovered = match[1];
  let startScrollable = useScrollable(trackRef, false);
  let endScrollable = useScrollable(trackRef, true);
  let compactActive = compact && containerHovered;
  let slideButtonsVisible = showSlideButtons || containerHovered;
  let itemsInView = useItemsInView(layout);
  let match$1 = {
    0: {
      className: "minWidth-xeuugli position-x1n2onr6",
      "data-style-src": "wino-gc:src/resources/layout-and-structure/SliderTrack.res.js:325"
    },
    1: {
      className: "minWidth-xeuugli position-x1n2onr6",
      style: {
        overflow: "hidden"
      },
      "data-style-src": "wino-gc:src/resources/layout-and-structure/SliderTrack.res.js:325"
    }
  }[!!compact << 0];
  let match$2 = trackStyleProps(gap, startScrollable, endScrollable, compactActive, stretchItems);
  return JsxRuntime.jsxs("div", {
    children: [JsxRuntime.jsx(SliderTrack$SlideButton, {
      show: slideButtonsVisible && startScrollable,
      compact: compact,
      trackRef: trackRef
    }), JsxRuntime.jsx("div", {
      children: React.Children.toArray(props.children).map((child, index) => {
        let match = itemsInView !== undefined ? itemStyleFromParams(itemsInView, gap, stretchItems) : adaptativeItemStyleProps(stretchItems);
        return JsxRuntime.jsx("div", {
          children: child,
          className: match.className,
          style: match.style
        }, index.toString());
      }),
      ref: Primitive_option.some(trackRef),
      "aria-label": "track",
      className: match$2.className,
      style: match$2.style
    }), JsxRuntime.jsx(SliderTrack$SlideButton, {
      end: true,
      show: slideButtonsVisible && endScrollable,
      compact: compact,
      trackRef: trackRef
    }), itemsInView !== undefined && showIndicator ? JsxRuntime.jsx(SliderTrack$PaginationIndicator, {
      itemsInView: itemsInView,
      gap: gap,
      trackRef: trackRef
    }) : null],
    ref: Primitive_option.some(ref),
    className: match$1.className,
    style: match$1.style
  });
}
let make = React.memo(SliderTrack);
export { make };
/* styles Not a pure module */